// extracted by mini-css-extract-plugin
export default {"invoiceRow":"Lsz81vWgYdY8i1UGS2GO","actionCell":"i2MM6rVwkEHT3ZxQXX6m"};